import React from 'react';

import { useRetryBeraPatch } from '@/hooks';
import { useBeraReportV2 } from '@/context/BeraReportV2';

import { PatchError } from './PatchError';
import { PatchProcessing } from './PatchProcessing';
import { toSummaryScope } from './utils';

export function VideoStatus(): JSX.Element {
	const {
		organizationId,
		companyId,
		jobSummary,
		isVideoProcessing,
		videoProcessingError,
		onPatchRetried
	} = useBeraReportV2();

	const { mutateAsync: retryBeraPatch, isLoading: isRetryingPatch } = useRetryBeraPatch();

	async function handleRetryPatch(): Promise<void> {
		const params = toSummaryScope({ summaryId: jobSummary.id, organizationId, companyId });

		const retried = await retryBeraPatch(params);

		if (retried) {
			onPatchRetried(retried.file);
		}
	}

	if (isVideoProcessing) {
		return <PatchProcessing />;
	}

	return <PatchError reason={videoProcessingError} loading={isRetryingPatch} onRetry={handleRetryPatch} />;
}
